<div class="config-item">
  <div class="config-input-container">
    <div class="config-label-container" style="width: 120px">
      <label class="config-label">{{ label }}</label>
    </div>
    <div [class.error-input-form]="errors.length > 0">
      <div style="display: flex">
        <mat-form-field style="width: 120px" appearance="outline">
          <div style="display: flex; flex-direction: column; align-items: flex-start">
            <div>
              <input
                matInput
                type="time"
                #inputDate
                ngDefaultControl
                [(ngModel)]="value"
                (ngModelChange)="onValueChange($event)"
                [step]="step != undefined ? step * 60 : 60"
                [disabled]="disabled"
                [placeholder]="placeholder"
                class="input-text-color"
              />
              <span class="config-input-unit">{{ unit }}</span>
              <div class="config-input-buttons">
                <mat-spinner diameter="10" *ngIf="disabled"></mat-spinner>
                <div *ngIf="!disabled">
                  <button
                    #upButton
                    class="config-input-button-up"
                    type="button"
                    (click)="incrementValue()"
                    (mousedown)="startIncrementing()"
                    (mouseup)="stopIncrementing()"
                    (mouseleave)="stopIncrementing()"
                    [disabled]="disabled"
                  >
                    <mat-icon class="input-arrows-style" color="#2F384B">keyboard_arrow_up</mat-icon>
                  </button>
                  <button
                    #downButton
                    class="config-input-button-down"
                    type="button"
                    (click)="decrementValue()"
                    (mousedown)="startDecrementing()"
                    (mouseup)="stopDecrementing()"
                    (mouseleave)="stopDecrementing()"
                    [disabled]="disabled"
                  >
                    <mat-icon class="input-arrows-style" color="#2F384B">keyboard_arrow_down</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-form-field>
        <mat-icon *ngIf="tooltip" class="info-icon" matTooltip="{{ tooltip }}">info</mat-icon>
      </div>
    </div>
  </div>
</div>
